import { createContext, useContext, useState, useEffect } from 'react';

const currencyRates = {
  USD: 1,
  QAR: 3.65,  // Qatar Riyal
  AED: 3.67,  // UAE Dirham
  INR: 83.0   // Indian Rupee
};

const currencySymbols = {
  USD: '$',
  QAR: 'QR',
  AED: 'AED',
  INR: '₹'
};

const currencyNames = {
  USD: 'US Dollar',
  QAR: 'Qatari Riyal',
  AED: 'UAE Dirham',
  INR: 'Indian Rupee'
};

const CurrencyContext = createContext(null);

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    return localStorage.getItem('ftasm_currency') || 'USD';
  });

  useEffect(() => {
    localStorage.setItem('ftasm_currency', currency);
  }, [currency]);

  // Convert price from USD (base currency) to selected currency
  const convertPrice = (priceInUSD) => {
    const rate = currencyRates[currency] || 1;
    return priceInUSD * rate;
  };

  // Format price with currency symbol
  const formatPrice = (priceInUSD) => {
    const converted = convertPrice(priceInUSD);
    const symbol = currencySymbols[currency];
    
    // Format based on currency
    if (currency === 'INR') {
      return `${symbol}${converted.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
    }
    
    return `${symbol} ${converted.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return (
    <CurrencyContext.Provider value={{ 
      currency, 
      setCurrency, 
      convertPrice, 
      formatPrice,
      currencySymbols,
      currencyNames,
      currencyRates
    }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const currencyOptions = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'QAR', symbol: 'QR', name: 'Qatari Riyal' },
  { code: 'AED', symbol: 'AED', name: 'UAE Dirham' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' }
];
